export default function Contact() {
  return (
    <div style={{ maxWidth: 700, margin: "0 auto", padding: 24 }}>
      <h1>Contact Us</h1>
      <div style={{ marginBottom: 24 }}>
        <b>Email:</b>{" "}
        <a href="mailto:servicertc42@gmail.com" style={{ color: "#222" }}>
          servicertc42@gmail.com
        </a>
      </div>
      <div>
        <b>Follow us on Facebook:</b>{" "}
        <a
          href="https://www.facebook.com/profile.php?id=100063748172809"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#222", textDecoration: "underline" }}
        >
          https://www.facebook.com/profile.php?id=100063748172809
        </a>
      </div>
    </div>
  );
}
